import { MutationTree } from 'vuex';
import { CalendarState } from './types';
import moment from 'moment';
import { EventResource } from '@/api/requests/calendar/types';
import Vue from 'vue';

export const mutations: MutationTree<CalendarState> = {
    /**
     * Add a calendar to the list.
     *
     * @param state
     * @param calendar
     */
    addCalendar(state, calendar) {
        state.calendars.push(calendar);
    },

    /**
     * Add events to the list.
     *
     * @param state
     * @param events
     */
    addEvents(state, events: EventResource[]) {
        // state.events = state.events.concat(events);
        Vue.set(state, 'events', state.events.concat(events));
    },

    /**
     * Remove a calendar from the list.
     *
     * @param state
     * @param calendarId
     */
    removeCalendar(state, calendarId) {
        state.calendars = state.calendars.filter((item) => item.id !== calendarId);
    },

    /**
     * Remove an event from the list.
     *
     * @param state
     * @param eventId
     */
    removeEvent(state, eventId) {
        state.events = state.events.filter((item) => item.id !== eventId);
    },

    /**
     * Reset the available calendar list.
     *
     * @param state
     */
    resetAvailableCalendars(state) {
        state.availableCalendars = [];
    },

    /**
     * Reset the calendar list.
     *
     * @param state
     */
    resetCalendars(state) {
        state.calendars = [];
    },

    /**
     * Reset the event list.
     *
     * @param state
     */
    resetEvents(state) {
        state.events = [];
    },

    /**
     * Reset the active events filters.
     *
     * @param state
     */
    resetEventFilters(state) {
        state.eventFilters = {};
    },

    /**
     * Set active event filters in calendar
     *
     * @param state
     * @param filters
     */
    setEventFilters(state, filters: any) {
        if (filters) {
            Vue.set(state.eventFilters, 'start', filters.start ? moment(filters.start) : undefined);
            Vue.set(state.eventFilters, 'end', filters.end ? moment(filters.end) : undefined);
            Vue.set(state.eventFilters, 'attendee', filters.attendee ?? undefined);
        }
    },

    /**
     * Reset the active filters.
     *
     * @param state
     */
    resetCalendarFilters(state) {
        state.calendarFilters = {};
    },

    /**
     * Set active filters in calendar
     *
     * @param state
     * @param filters
     */
    setCalendarFilters(state, filters: any) {
        Vue.set(state.calendarFilters, 'types', filters && filters.types ? filters.types : undefined);
    },

    /**
     * Set the calendar list available for subscription.
     *
     * @param state
     * @param calendars
     */
    setAvailableCalendars(state, calendars) {
        state.availableCalendars = calendars;
    },

    /**
     * Set the calendar list.
     *
     * @param state
     * @param calendars
     */
    setCalendars(state, calendars) {
        state.calendars = calendars;
    },

    /**
     * Update a calendar.
     *
     * @param state
     * @param calendar
     */
    updateCalendar(state, calendar) {
        const index = state.calendars.findIndex((item) => item.id === calendar.id);
        state.calendars.splice(index, 1, calendar);
    },

    /**
     * Update an event.
     *
     * @param state
     * @param event
     */
    updateEvent(state, event: EventResource) {
        const index = state.events.findIndex((item) => item.id === event.id);
        state.events.splice(index, 1, event);
    },
};
